import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { CheckIcon, LockIcon, MailIcon } from 'lucide-react';
const combos = [{
  id: 1,
  name: 'COMBO 2: EL MÁS ELEGIDO',
  subtitle: 'Creación + corrección inteligente.',
  originalPrice: '$99.000',
  price: '$29.990',
  discount: '70%',
  checkout: 'https://checkout8.rosetadigital.com/cart/51845195235559:1',
  badge: 'MÁS VENDIDO',
  items: [{
    type: 'manual',
    text: 'Manual Principal: IA Práctica para Docentes',
    highlight: false
  }, {
    type: 'manual',
    text: 'Manual 2: Sistema de Corrección Inteligente para Docentes',
    highlight: true
  }, {
    type: 'bonus',
    text: 'Bonus: Banco Universal de Prompts Docentes Inteligentes'
  }, {
    type: 'bonus',
    text: 'Bonus: Sistema Planificación 10X Paso a Paso'
  }, {
    type: 'bonus',
    text: 'Bonus: Creá tu Propio Material Digital'
  }, {
    type: 'info',
    text: 'Material digital (PDF) — enviado por mail'
  }]
}, {
  id: 0,
  name: 'COMBO 1: SISTEMA BASE',
  subtitle: 'Para empezar a crear con IA.',
  originalPrice: '$64.000',
  price: '$19.990',
  discount: '69%',
  checkout: 'https://checkout8.rosetadigital.com/cart/51827041960167:1',
  badge: null,
  items: [{
    type: 'manual',
    text: 'Manual Principal: IA Práctica para Docentes',
    highlight: false
  }, {
    type: 'bonus',
    text: 'Bonus: Banco Universal de Prompts Docentes Inteligentes'
  }, {
    type: 'bonus',
    text: 'Bonus: Sistema Planificación 10X Paso a Paso'
  }, {
    type: 'bonus',
    text: 'Bonus: Creá tu Propio Material Digital'
  }, {
    type: 'info',
    text: 'Material digital (PDF) — enviado por mail'
  }]
}, {
  id: 2,
  name: 'COMBO 3: SISTEMA COMPLETO',
  subtitle: 'Dominio total de la enseñanza con IA.',
  originalPrice: '$129.000',
  price: '$39.990',
  discount: '69%',
  checkout: 'https://checkout8.rosetadigital.com/cart/51845273649383:1',
  badge: null,
  items: [{
    type: 'manual',
    text: 'Manual Principal: IA Práctica para Docentes',
    highlight: false
  }, {
    type: 'manual',
    text: 'Manual 2: Sistema de Corrección Inteligente para Docentes',
    highlight: false
  }, {
    type: 'manual',
    text: 'Manual 3: Actividades Innovadoras con IA',
    highlight: true
  }, {
    type: 'bonus',
    text: 'Bonus: Banco Universal de Prompts Docentes Inteligentes'
  }, {
    type: 'bonus',
    text: 'Bonus: Sistema Planificación 10X Paso a Paso'
  }, {
    type: 'bonus',
    text: 'Bonus: Creá tu Propio Material Digital'
  }, {
    type: 'info',
    text: 'Material digital (PDF) — enviado por mail'
  }]
}];
export function ComboSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const [selected, setSelected] = useState(1);
  const activeCombo = combos.find(c => c.id === selected)!;
  return <section id="combos" className="w-full bg-offwhite pt-8 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-28">
      <div ref={ref} className={`max-w-2xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-29">
        {/* Section Header */}
        <div className="text-center mb-10" data-id="element-30">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-3" data-id="element-31">
            ELEGÍ TU COMBO
          </span>
          <h2 className="font-playfair font-bold text-3xl sm:text-[44px] leading-[1.2] text-navy" data-id="element-32">
            Elegí el Nivel que Mejor se Adapte a Vos
          </h2>
        </div>

        {/* Dark Card */}
        <div className="bg-[#1a1f2e] rounded-2xl overflow-hidden shadow-2xl" data-id="element-33">
          {/* Combo Options */}
          <div className="divide-y divide-white/10" data-id="element-34">
            {combos.map(combo => {
            const isActive = selected === combo.id;
            return <div key={combo.id} className={`transition-opacity duration-300 ${isActive ? 'opacity-100' : 'opacity-70 hover:opacity-90'}`} data-id="element-35">
                  {/* Row Header */}
                  <button id={combo.id === 1 ? 'combo-2' : undefined} onClick={() => setSelected(combo.id)} className="w-full px-5 sm:px-6 py-4 flex items-center justify-between text-left transition-colors duration-200 hover:bg-white/5" data-id="element-36">
                    <div className="flex items-center gap-3 min-w-0" data-id="element-37">
                      {/* Radio */}
                      <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all duration-200 ${isActive ? 'border-gold bg-gold' : 'border-gray-600'}`} data-id="element-38">
                        {isActive && <div className="w-2 h-2 rounded-full bg-[#1a1f2e]" data-id="element-39" />}
                      </div>
                      <div className="min-w-0" data-id="element-40">
                        <div className="flex items-center gap-2 flex-wrap" data-id="element-41">
                          <span className={`font-montserrat font-extrabold text-sm sm:text-base ${isActive ? 'text-white' : 'text-gray-400'}`} data-id="element-42">
                            {combo.name}
                          </span>
                          {combo.badge && <span className="bg-gold text-[#1a1f2e] font-montserrat font-bold text-[10px] px-2 py-0.5 rounded" data-id="element-43">
                              {combo.badge}
                            </span>}
                        </div>
                        <span className={`font-inter text-xs sm:text-sm block mt-0.5 ${isActive ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-44">
                          {combo.subtitle}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0 ml-3" data-id="element-45">
                      <span className="font-inter text-gray-500 line-through text-xs" data-id="element-46">
                        {combo.originalPrice}
                      </span>
                      <span className="bg-crimson text-white font-montserrat font-bold text-[10px] px-1.5 py-0.5 rounded" data-id="element-47">
                        {combo.discount}
                      </span>
                      <div className="text-right" data-id="element-48">
                        <span className="font-inter text-gray-500 text-[10px] block leading-none" data-id="element-49">
                          ARS
                        </span>
                        <span className={`font-montserrat font-extrabold text-xl sm:text-2xl leading-none ${isActive ? 'text-white' : 'text-gray-400'}`} data-id="element-50">
                          {combo.price.replace('$', '')}
                        </span>
                      </div>
                    </div>
                  </button>

                  {/* Expanded Content */}
                  <div className={`transition-all duration-500 ease-in-out overflow-hidden ${isActive ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-51">
                    <div className="px-5 sm:px-6 pb-5 pt-2" data-id="element-52">
                      <p className="font-montserrat font-bold text-[11px] text-gray-400 uppercase tracking-wider mb-3" data-id="element-53">
                        INCLUYE:
                      </p>
                      <ul className="space-y-2.5" data-id="element-54">
                        {combo.items.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-55">
                            {item.type === 'manual' && <CheckIcon className={`flex-shrink-0 mt-0.5 ${item.highlight ? 'text-gold' : 'text-gray-400'}`} size={16} data-id="element-56" />}
                            {item.type === 'bonus' && <CheckIcon className="text-emerald flex-shrink-0 mt-0.5" size={16} data-id="element-57" />}
                            {item.type === 'info' && <MailIcon className="text-gray-500 flex-shrink-0 mt-0.5" size={16} data-id="element-58" />}
                            <span className={`text-sm leading-snug ${item.type === 'info' ? 'font-inter text-gray-500' : item.highlight ? 'font-inter font-bold text-gold' : 'font-inter text-gray-300'}`} data-id="element-59">
                              {item.text}
                              {item.type === 'bonus' && <span className="text-emerald font-bold" data-id="element-60">
                                  {' '}
                                  (Gratis)
                                </span>}
                            </span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </div>;
          })}
          </div>

          {/* CTA Button */}
          <div className="px-5 sm:px-6 pb-5 pt-2" data-id="element-61">
            <a href={activeCombo.checkout} target="_blank" rel="noopener noreferrer" className="w-full inline-block text-center bg-gold text-[#1a1f2e] font-montserrat font-extrabold text-base sm:text-lg py-4 px-6 rounded-xl hover:scale-[1.02] hover:bg-[#ffb43a] transition-all duration-300 shadow-[0_4px_24px_rgba(245,166,35,0.35)]" data-id="element-62">
              COMPRAR AHORA
            </a>
          </div>

          {/* Trust Badges */}
          <div className="px-5 sm:px-6 pb-5 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-63">
            <div className="flex items-center gap-1.5 text-gray-400 text-xs font-inter" data-id="element-64">
              <LockIcon size={13} data-id="element-65" />
              <span data-id="element-66">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-1.5 text-gray-400 text-xs font-inter" data-id="element-67">
              <CheckIcon size={13} data-id="element-68" />
              <span data-id="element-69">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-1.5 text-gray-400 text-xs font-inter" data-id="element-70">
              <MailIcon size={13} data-id="element-71" />
              <span data-id="element-72">PDF por email</span>
            </div>
            <div className="flex items-center gap-1.5 text-gray-400 text-xs font-inter" data-id="element-73">
              <CheckIcon size={13} data-id="element-74" />
              <span data-id="element-75">Garantía 7 días</span>
            </div>
          </div>
        </div>

        {/* Bottom Trust Bar */}
        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-76">
          <div className="flex items-center gap-1.5 text-navy font-inter text-sm" data-id="element-77">
            <CheckIcon size={16} className="text-emerald" data-id="element-78" />
            <span data-id="element-79">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-1.5 text-navy font-inter text-sm" data-id="element-80">
            <CheckIcon size={16} className="text-emerald" data-id="element-81" />
            <span data-id="element-82">Material descargable</span>
          </div>
          <div className="flex items-center gap-1.5 text-navy font-inter text-sm" data-id="element-83">
            <CheckIcon size={16} className="text-emerald" data-id="element-84" />
            <span data-id="element-85">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5 text-navy font-inter text-sm" data-id="element-86">
            <CheckIcon size={16} className="text-emerald" data-id="element-87" />
            <span data-id="element-88">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}